export async function registerFCMUser(user: any, appId: string) {}

export async function unregisterFCMUser() {}
